export default "__VITE_ASSET__BfWiDio___"